import cn from "classnames"
import styles from "./FiltersTab.module.scss"

import type { FiltersTabProps } from "."

export const FiltersTab = (props: FiltersTabProps) => {
  const {
    showPlaceholder,
    tabPosition,
    SearchComponent,
    isKaiOpen,
    scrollY = isKaiOpen
  } = props

  return (
    <div
      className={cn(
        styles.container,
        isKaiOpen && styles.kaiOpen,
        scrollY && styles.scrollY,
        showPlaceholder && styles.showPlaceholder,
        tabPosition === "left" && styles.tabPositionLeft
      )}
      data-component-name="filters-tab-component"
    >
      {SearchComponent}
    </div>
  )
}
